/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface EmployerEnrichRequest {
  /**
     * @minLength 1
     * @maxLength 2000
     */
  website: string;
  /** Specific fields to enrich. If null, all fields are enriched. */
  fields?: ('mission_vision' | 'funding_traction' | 'culture_principles' | 'benefits')[] | null;
}
